import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Typography, Button, Table, Select, Tag, Modal, Space } from "antd";
import { PlusOutlined, DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import _get from "lodash/get";
import moment from "moment";

import { 
  getSystemNotificationListRequest,
  deleteAllSystemNotificationsRequest 
} from "providers/SystemNotificationProvider/slice";
import SystemNotificationColumn from "components/Columns/SystemNotificationColumn";
import Helper from "utils/helpers";
import "./styles.less";

const { Option } = Select;

const SystemNotificationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const notificationList = useSelector((state) => {
    console.log("System notification state:", state.systemNotification);
    return state.systemNotification.notificationList;
  });
  const pagination = useSelector((state) => 
    state.systemNotification.pagination
  );
  const isLoading = useSelector((state) => 
    state.systemNotification.isLoading
  );

  // Load notification list
  const loadNotificationList = useCallback(
    (params = {}) => {
      const requestParams = {
        page: params.page || 1,
        limit: params.limit || 20,
      };
      dispatch(getSystemNotificationListRequest(requestParams));
    },
    [dispatch]
  );

  useEffect(() => {
    loadNotificationList({});
  }, [loadNotificationList]);

  const handleTableChange = (tablePagination, filters, sorter) => {
    loadNotificationList({
      page: tablePagination.current,
      limit: tablePagination.pageSize,
    });
  };

  const handleDeleteAll = () => {
    Modal.confirm({
      title: "Xác nhận xóa tất cả thông báo",
      icon: <ExclamationCircleOutlined />,
      content: "Bạn có chắc chắn muốn xóa tất cả thông báo hệ thống? Hành động này không thể hoàn tác.",
      okText: "Xóa tất cả",
      okType: "danger",
      cancelText: "Hủy",
      onOk: () => {
        dispatch(deleteAllSystemNotificationsRequest())
          .then((result) => {
            const deletedCount = result?.payload?.deletedNotifications || 0;
            const deletedJobs = result?.payload?.deletedJobs || 0;
            
            Helper.toastr(
              "Xóa thành công",
              `Đã xóa ${deletedCount} thông báo và ${deletedJobs} tác vụ liên quan`,
              "success"
            );
            
            // Reload the list after deletion
            loadNotificationList({});
          })
          .catch((error) => {
            console.error("Delete all notifications error:", error);
            Helper.toastr(
              "Xóa thất bại",
              "Có lỗi xảy ra khi xóa thông báo. Vui lòng thử lại.",
              "error"
            );
          });
      },
    });
  };

  const columns = SystemNotificationColumn({
    onRefresh: () => loadNotificationList(),
    pagination: pagination,
  });

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "high":
        return "red";
      case "normal":
        return "blue";
      case "low":
        return "green";
      default:
        return "default";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "green";
      case "inactive":
        return "red";
      default:
        return "default";
    }
  };

  return (
    <div className="system-notification-list-wrapper">
      <Row className="system-notification-list-header" justify="space-between" align="middle">
        <Row align="middle">
          <Typography.Title level={4}>Thông báo hệ thống</Typography.Title>
        </Row>
        <Space>
          <Button
            danger
            icon={<DeleteOutlined />}
            size="large"
            onClick={handleDeleteAll}
            disabled={notificationList.length === 0}
          >
            Xóa tất cả
          </Button>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            size="large"
            style={{ width: 150 }}
            onClick={() => navigate("/system_notifications/create")}
          >
            Tạo thông báo
          </Button>
        </Space>
      </Row>
      <div className="system-notification-list-content">
        <Table
          columns={columns}
          dataSource={notificationList}
          rowKey="_id"
          loading={isLoading}
          pagination={{
            current: pagination.page,
            pageSize: pagination.limit,
            total: pagination.total,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} của ${total} thông báo`,
          }}
          onChange={handleTableChange}
          scroll={{ x: 1200 }}
          locale={{ emptyText: "Không có thông báo nào." }}
        />
      </div>
    </div>
  );
};

export default SystemNotificationList; 